import { render, staticRenderFns } from "./PrintLayout.vue?vue&type=template&id=2501b5ac"
import script from "./PrintLayout.vue?vue&type=script&lang=js"
export * from "./PrintLayout.vue?vue&type=script&lang=js"
import style0 from "./PrintLayout.vue?vue&type=style&index=0&id=2501b5ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports